"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = require("eventemitter3");
function connect(url, protocols) {
    return wx.connectSocket({
        url: url,
        protocols: protocols
    });
}
exports.connect = connect;
var WeappWebSocket = /** @class */ (function (_super) {
    __extends(WeappWebSocket, _super);
    function WeappWebSocket(instance) {
        var _this = _super.call(this) || this;
        _this.instance = instance;
        instance.onOpen(function (event) {
            _this.emit('open', event);
        });
        instance.onMessage(function (event) {
            _this.emit('message', event);
        });
        instance.onError(function (event) {
            _this.emit('error', event);
        });
        instance.onClose(function (event) {
            _this.emit('close', event);
        });
        return _this;
    }
    WeappWebSocket.prototype.send = function (data) {
        this.instance.send({
            data: data
        });
    };
    WeappWebSocket.prototype.close = function (code, reason) {
        try {
            this.instance.close({
                code: code,
                reason: reason
            });
        }
        catch (error) {
            // noop
        }
    };
    WeappWebSocket.prototype.addEventListener = function (type, listener) {
        this.on(type, listener);
    };
    WeappWebSocket.prototype.removeEventListener = function (type, listener) {
        this.off(type, listener);
    };
    Object.defineProperty(WeappWebSocket.prototype, "readyState", {
        get: function () {
            return this.instance.readyState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WeappWebSocket.prototype, "CLOSED", {
        get: function () {
            return this.instance.CLOSED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WeappWebSocket.prototype, "CLOSING", {
        get: function () {
            return this.instance.CLOSING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WeappWebSocket.prototype, "CONNECTING", {
        get: function () {
            return this.instance.CONNECTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WeappWebSocket.prototype, "OPEN", {
        get: function () {
            return this.instance.OPEN;
        },
        enumerable: true,
        configurable: true
    });
    return WeappWebSocket;
}(EventEmitter.EventEmitter));
exports.WeappWebSocket = WeappWebSocket;
//# sourceMappingURL=weapp.js.map